// HeaderTitle
import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

const Box = styled.div`
  background: rgba(0, 0, 0, 0.6);
  color: #fff;
  padding: 1vw 2.5vw;
  border: solid 1.2vw rgb(68, 108, 222);
  box-sizing: border-box;
  @media (min-width: 1400px) {
    padding: 2vw 4vw;
  }
`;
const Wrapper = styled.div`
  justify-content: center;
  transform: translateZ(-80px);
  margin-top: 0;
  h1 {
    font-family: 'Times New Roman', Times, serif;
    font-size: 11.7vw;
    max-font-size: 140px;
    color: rgb(255, 255, 255);
    text-transform: uppercase;
    letter-spacing: 0.2rem;
    margin-bottom: 0px;
    line-height: 1.2;
  }
  h1 span {
    font-family: 'remedydouble', 'Times New Roman', Times, serif;
    font-size: 13.6vw;
    letter-spacing: 0.25rem;
    line-height: 1;
  }
  .tag {
    font-family: 'Times New Roman', Times, serif;
    font-size: 4.1vw;
    margin-top: 0;
    margin-bottom: 2vw;
    letter-spacing: 0.3vw;
  }
  p {
    font-size: 3.1vw;
  }
  .tag span {
    font-family: 'Quicksand-Regular', arial, sans-serif;
    font-size: 0.7rem;
  }

  // Min-Width 660px
  @media (min-width: 660px) {
    h1 {
      font-size: 10vw;
    }
    h1 span {
      font-size: 11.5vw;
    }
    .tag {
      font-size: 4.1vw;
    }
    p {
      font-size: 2.7vw;
    }
  }
  // Min-Width 900px
  @media (min-width: 900px) {
    h1 {
      font-size: 9.5vw;
    }
    h1 span {
      font-size: 8.5vw;
    }
    .tag {
      font-size: 3.5vw;
    }
    p {
      font-size: 2.5vw;
    }
  }
  // Min-width 1400px
  @media (min-width: 1400px) {
    h1 {
      font-size: 99px;
    }
    h1 span {
      font-size: 115px;
    }
    .tag {
      font-size: 35px;
    }
    p {
      font-size: 35px;
    }
  }
  // landscape
  @media (orientation: landscape) {
    /* justify-content: flex-start; */
    h1 {
      font-size: 8vw;
    }
    h1 span {
      font-size: 9.1vw;
    }
    .tag {
      font-size: 2.8vw;
      margin-top: 0.6vw;
      line-height: 1;
    }
    p {
      font-size: 2.3vw;
      margin-top: 0;
      margin-bottom: 5px;
    }
  }
  // Landscape min-height 450px
  @media (orientation: landscape) and (min-height: 450px) {
    h1 {
      font-size: 8vw;
    }
    h1 span {
      font-size: 9vw;
    }
    .tag {
      font-size: 2.8vw;
    }
    p {
      font-size: 2vw;
    }
  }
  // Landscape min-width 1400px
  @media (orientation: landscape) and (min-height: 450px) and (min-width: 1400px) {
    h1 {
      font-size: 96px;
    }
    h1 span {
      font-size: 110px;
    }
    .tag {
      font-size: 28px;
    }
    p {
      font-size: 27px;
    }
  }
`;
function HeaderTitle(props) {
  return (
    <Wrapper
      className="header-header-title uk-flex uk-flex-middle uk-flex-center uk-flex-1"
      tabindex="0"
    >
      <Box className="uk-text-center uk-animation-fade">
        <h1>
          {props.line1}
          <br />
          <span>{props.line2}</span>
        </h1>
        <div className="tag">
          {props.tagline}
          <span className="uk-text-top">&#8482;</span>
        </div>
        <p>
          {props.descLine1}
          <br />
          {props.descLine2}
        </p>
      </Box>
    </Wrapper>
  );
}

HeaderTitle.propTypes = {
  line1: PropTypes.string,
  line2: PropTypes.string,
  tagline: PropTypes.string,
  descLine1: PropTypes.string,
  descLine2: PropTypes.string,
};

export default HeaderTitle;



// WEBPACK FOOTER //
// ./src/features/header/HeaderTitle.js